import { useMutation } from "@tanstack/react-query";
import { IUseUpdateOfferMutationResponse } from "../utils/types";
import { queryClient } from "../App";
import { useUploadProgress } from "../context/UploadProgressContext";
import axios from "axios";

const useUpdateOurStory = ({
  id,
}: {
  id: string | undefined;
}): IUseUpdateOfferMutationResponse => {
  const { setUploadPercentage, setProcessing } = useUploadProgress();

  return useMutation({
    mutationFn: async (data: any) => {
      const url = window.location.pathname;
      const parts = url.split("/");
      const hotelcode = parts[1];

      setProcessing(true); 
      setUploadPercentage(0);
      
      const response = await axios({
        headers: {
          hotelcode,
          "Content-Type": "multipart/form-data",
        },
        method: "PUT",
        data: data,
        url: `/edit-our-story/${id}`,
        baseURL: process.env.REACT_APP_RESERVATION_API,
        onUploadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent;
          if (total) {
            const progress = Math.round((loaded * 100) / total);
            setUploadPercentage(progress);
          }
        },
      });

      // Simulate processing progress (you'll replace this with actual progress events)
      const interval = setInterval(() => {
        setUploadPercentage((prev: number) => {
          const newProgress = Math.min(prev + 5, 100);
          if (newProgress === 100) {
            clearInterval(interval);
          }
          return newProgress;
        });
      }, 500);

      return response.data;
    },
    onSettled: () => {
      setProcessing(false);
    },
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ["our-story"] });
    },
  });
};

export default useUpdateOurStory;
